import styled, { css } from 'styled-components';
import { colors2, globalLightboxStyle } from 'oolib';
import { globalScrollbarStyling } from 'oolib/dist/v2/themes/globalStyles';
import {
  CONTAINER_MAX_HEIGHT,
  CONTAINER_WIDTH,
  Z_INDEX_BASE,
  Z_INDEX_SUB_LIGHTBOX,
  BOX_SHADOW
} from './constants';

export const StyledMenuContainer = styled.div`
  border-radius: 0.8rem;
  background-color: ${colors2.white};
  display: flex;
  flex-direction: column;
  max-height: ${CONTAINER_MAX_HEIGHT}rem;
  overflow: hidden;
  overflow-y: auto;

  padding: 0.4rem;
  box-shadow: ${BOX_SHADOW};
  ${globalScrollbarStyling}
`;


export const StyledLevelContainer  = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledLevelHeader = styled.div`
  padding: 0.6rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledLevelContent = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 0.4rem;
`;

export const StyledSubLightbox = styled.div`
  position: absolute;
  top: ${props => props.top || 0}px;
  background: white;
  border-radius: 0.8rem;
  border: 1px solid ${colors2.grey10};
  width: ${CONTAINER_WIDTH}rem;
  z-index: ${Z_INDEX_SUB_LIGHTBOX};
  max-height: ${CONTAINER_MAX_HEIGHT}rem;
  ${globalScrollbarStyling}
  box-shadow: ${BOX_SHADOW};

  visibility: ${props => props.visibility || 'hidden'};
`;

export const StyledSearchWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: ${Z_INDEX_BASE};
  background: white;
  margin-bottom: 0.4rem;
`;

export const StyledActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const StyledOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 0.4rem;
  border-radius: 8px;
  width: 100%;
`;